/**
 * oauth 서버 에러 타입
 */
export default class ErrorTypeAuthServer {
    /** 에러 코드 ex) invalid_request */
    error = '';
    /** 에러 메시지 ex) Authorization header is not supported for authentication. */
    // eslint-disable-next-line camelcase
    error_description = '';
    constructor(error = {}) {
        Object.assign(this, error);
    }
}
